import * as React from "react";
const SvgGift = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.257 4.268c-.798.29-1.896.438-2.976.468.453-.688 1.05-1.427 1.673-1.93.492-.396.899-.564 1.196-.564.227-.001.538.094.888.654.29.465.215.667.16.763-.097.173-.373.402-.941.609Zm2.052-2.167C17.76 1.22 17.018.739 16.146.74c-.801.003-1.539.418-2.133.897-.779.628-1.486 1.51-2.013 2.317-.527-.808-1.234-1.689-2.013-2.317-.594-.48-1.332-.894-2.133-.896C6.982.739 6.241 1.22 5.69 2.1c-.483.772-.6 1.58-.193 2.298.073.13.16.25.258.36H1a.75.75 0 0 0-.75.75v5c0 .414.336.75.75.75h1.25v11.25c0 .414.336.75.75.75h18a.75.75 0 0 0 .75-.75v-11.25H23a.75.75 0 0 0 .75-.75v-5a.75.75 0 0 0-.75-.75h-4.755c.098-.11.185-.23.258-.36.408-.718.29-1.526-.194-2.298Zm1.941 9.157v10.5H13.5v-10.5h6.75Zm-9.75 0v10.5H3.75v-10.5h6.75Zm3-1.5h8.75v-3.5H13.5v3.5Zm-3-3.5v3.5H1.75v-3.5h8.75Zm.219-1.522c-1.08-.03-2.178-.178-2.976-.468-.568-.207-.844-.436-.942-.609-.054-.096-.13-.298.161-.763.35-.56.661-.655.888-.654.297 0 .704.168 1.196.564.623.503 1.22 1.242 1.673 1.93Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgGift;
